'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseFormPDF', ['$scope', 'FBForms', '$uibModal', function ($scope, FBForms, $uibModal) {
        $scope.resetForm();
        $scope.saving = false;

        $scope.typeOptions = [
            { id: false, name: 'Basic' },
            { id: true, name: 'XSLT' }
        ];

        $scope.nodeOptions = [
            { id: false, name: 'Old' },
            { id: true, name: 'New' }
        ];

        $scope.save = function () {
            $uibModal.open({
                templateUrl: paths.app + 'licenses/components/license-form-pdf/license-form-pdf-modal.html',
                controller: 'InternalLicenseFormPDFModal',
                backdrop: false,
                keyboard: false
            }).result.then(function (applyDocumentTypeHistorically) {
                $scope.saving = true;

                FBForms.save({ form: $scope.form, license_id: $scope.licenseID }).then(function (form) {
                    if (form != null) {
                        if (form.pages.length > 0) {
                            form.pages[0].tab_active = true;
                        }
                        $scope.setMasterForm(form);
                        if (applyDocumentTypeHistorically) {
                            FBForms.updateFormResponseDocumentTypeHistorically({ formId: form.id, documentTypeId: form.document_type_id}).then(function (res) {
                                $scope.saving = false;
                            });
                        } else {
                            $scope.saving = false;
                        }
                    }
                })
            }, function (unhandledRes) {
                // can handle unhandled resolves here if needed
            });
        }
    }])
;